import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class LogoutService {
  private storageService = inject(StorageService);
  private _Router = inject(Router);

  public logout() {
    this.storageService.removeToken();
    this._Router.navigate(['auth/login']);
  }

}
